var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyClipboardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0839 19.1269H8.32297C7.69327 19.1269 7.15668 18.9052 6.7132 18.4617C6.26972 18.0182 6.04797 17.4816 6.04797 16.8519V3.30625C6.04797 2.67653 6.26972 2.13994 6.7132 1.69648C7.15668 1.25299 7.69327 1.03125 8.32297 1.03125H15.2393L21.3589 7.15083V16.8519C21.3589 17.4816 21.1371 18.0182 20.6936 18.4617C20.2502 18.9052 19.7136 19.1269 19.0839 19.1269ZM14.0838 8.30625V3.30625H8.32297V16.8519H19.0839V8.30625H14.0838ZM4.04797 23.4019C3.41826 23.4019 2.88167 23.1802 2.4382 22.7367C1.9947 22.2932 1.77295 21.7566 1.77295 21.1269V7.19865H4.04797V21.1269H15.1018V23.4019H4.04797Z",
    fill: "#58595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClipboardIcon);
export default __webpack_public_path__ + "static/media/CopyClipboardIcon.3eed1d5a8d6ae22a17184d488c2375d3.svg";
export { ForwardRef as ReactComponent };